import {useMemo, type FC, useEffect, useState} from "react";
import {
    HeaderForm,
    SwitchContainer,
    TitleWrap,
    WorkspaceName,
    QuestionWrapper
} from "./method-form.styles";
import {
    Back,
    CheckBoxContainer,
    FormWrapper,
    StyledSelect,
    StyledTextField,
    palette,
    VerticalCenter
} from "@src/core/styles";
import {RoutePageTitle} from "../../form-components.styles";
import type {MethodFormProps} from "./method-form.types";
import {
    FieldGroupWrapper,
    FieldGroup,
} from "@src/pages/login-page/login-page.styles";
import {FieldGroupRow} from "@src/pages/registration-page/registration-page.styles";
import {Controller, useForm} from "react-hook-form";
import {
    ButtonGroup,
    ButtonGroupWrapper,
    DeleteIconWrapper,
} from "../workspace-form/workspace-form.styles";
import {Button} from "@src/components";
import {ReactComponent as Check} from "@src/core/icons/check.svg";
import {ReactComponent as DeleteIcon} from "@src/core/icons/delete.svg";
import {ReactComponent as CopyIcon} from "@src/core/icons/copy.svg";
import {joiResolver} from "@hookform/resolvers/joi";
import {formRouteSchema} from "@src/core/schemas";
import type {
    Method,
    RouteErrorResponse,
    RouteErrors,
    RouteFormValues,
} from "@src/core/types";
import {
    Checkbox,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    MenuItem,
} from "@mui/material";
import {APP_ROUTES, methods} from "@src/core/constants";
import {IOSSwitch} from "@src/components/ui";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {useMutation, useQuery} from "@tanstack/react-query";
import {Authentication, Route, Workspace} from "@src/core/services";
import {getKeyWordsForm} from "@src/core/utils";
import {
    StyledDialog,
    StyledDialogContentText,
} from "../../../route-component/components/workspace-menu/workspace-menu.styles";
import {enqueueSnackbar} from "notistack";
import {Text} from "../../../../route-management-page.styles";
import {ReactComponent as Arrow} from "@src/core/icons/arrow.svg";
import { ReactComponent as QuestionIcon } from "@src/core/icons/question.svg";
import {AxiosError} from "axios";
import CodeMirror from '@uiw/react-codemirror';
import {javascript} from '@codemirror/lang-javascript';
import {php} from '@codemirror/lang-php';
import React from 'react';

export const MethodForm: FC<MethodFormProps> = ({titlePage}) => {
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const {workspaceId, routeId} = useParams();
    const [openDialog, setOpenDialog] = useState(false);
    const [workspaceName, setWorkspaceName] = useState<string>("");
    const [errorsRequest, setErrorsRequest] = useState<RouteErrors>();
    const [responseData, setResponseData] = useState<string>("");
    const [valuee, setValuee] = React.useState("");

    const {formMethod} = getKeyWordsForm(pathname);

    const {data: route, isLoading} = useQuery({
        queryKey: ["route", routeId],
        queryFn: () => routeId ?
            Route.getOne({
                routeId: routeId ?? "",
            }) : undefined,
    });

    const {data: info} = useQuery({
        queryKey: ["info"],
        queryFn: () => Authentication.info(),
        onSuccess: (data) => {
        },
        onError: (error) => {
            console.log(error, "error info");
        },
    });

    const inititalValues: RouteFormValues | undefined = useMemo(() => {
        if (isLoading) {
            return undefined;
        }
        if (!isLoading) {
            if (route?.data && routeId) {
                const request = route?.data;

                try {
                    // setResponseData(JSON.parse(request.response_body || ""))
                    setResponseData(request.response_body || "")
                } catch (e) {
                    setResponseData(request.response_body || "")
                }

                return {
                    name: request.name,
                    description: request.description || "",
                    method: request.method,
                    url: request.url,
                    http_code: request.http_code,
                    content_type: request.content_type,
                    response: request.response_body || "",
                    active: request.active,
                    logging_enable: request.logging_enable,
                    delay: request.delay,
                };
            } else {
                return undefined;
            }
        }
    }, [isLoading, route?.data, routeId]);

    const defaultCreateValues = {
        name: "",
        description: "",
        method: "get" as Method,
        url: "",
        http_code: 200,
        content_type: "",
        response: "",
        active: false,
        logging_enable: false,
        delay: 0
    };

    const {
        handleSubmit,
        control,
        formState: {errors, isValid},
        reset,
        setValue,
        getValues,
    } = useForm<RouteFormValues>({
        mode: "onChange",
        resolver: joiResolver(formRouteSchema),
        defaultValues:
            formMethod === "update"
                ? inititalValues ?? defaultCreateValues
                : defaultCreateValues,
    });

    useEffect(() => {
        reset(inititalValues);
    }, [inititalValues, reset, route?.data]);

    useEffect(() => {
        if (formMethod === "create") reset(defaultCreateValues);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formMethod, reset]);

    const {data: workspaces, refetch} = useQuery({
        queryKey: ["workspaces"],
        queryFn: () => Workspace.getAll(),
        onSuccess: (data) => {
        },
        onError: (error) => {
            console.log(error, "error workspace");
        },
        enabled: false,
    });

    const {mutate: createRoute} = useMutation(Route.create, {
        onSuccess: (response) => {
            enqueueSnackbar("Метод создан", {
                variant: "reportComplete",
                className: "success",
                preventDuplicate: true,
            });
            refetch();
            reset();
            navigate(
                `${APP_ROUTES.WORKSPACE}/${workspaceId}${APP_ROUTES.ROUTES}/update/${response.data.id}`,
            );
        },
        onError: (error: AxiosError<RouteErrorResponse>) => {
            setErrorsRequest(error.response?.data.errors);
            // console.log(error.response?.data.errors);
            // console.log(errorsRequest);
            if (error.response?.data.errors.access) {
                enqueueSnackbar("Ваш тарифный план не позволяет больше добавлять адреса", {
                    variant: "reportComplete",
                    className: "success",
                    preventDuplicate: true,
                });
            }
        },
    });

    const {mutate: updateRoute} = useMutation(Route.update, {
        onSuccess: (response) => {
            enqueueSnackbar("Метод обновлен", {
                variant: "reportComplete",
                className: "success",
                preventDuplicate: true,
            });
            refetch();
        },
        onError: (error: AxiosError<RouteErrorResponse>) => {
            setErrorsRequest(error.response?.data.errors);
        },
    });

    const {mutate: deleteRoute} = useMutation(Route.delete, {
        onSuccess: (response) => {
            setOpenDialog(false);
            navigate(`${APP_ROUTES.WORKSPACE}/${workspaceId}/routes`);
            enqueueSnackbar("Метод удален", {
                variant: "reportComplete",
                className: "success",
                preventDuplicate: true,
            });
            reset();
            refetch();
        },
        onError: (error: Error) => {
            // код в случае ошибки
        },
    });

    const deleteMethod = () => {
        setOpenDialog(true);
    };
    const handleClose = () => {
        setOpenDialog(false);
    };

    const onSubmit = (data: RouteFormValues) => {
        const reqCreate = {
            ...data,
            work_space_id: workspaceId,
            method: data.method,
            active: data.active.toString(),
            logging_enable: data.logging_enable.toString(),
        };
        const reqUpdate = {
            route_id: routeId,
            body: {
                ...data,
                work_space_id: workspaceId,
                method: data.method,
                active: data.active ? "true" : "false",
                logging_enable: data.logging_enable ? "true" : "false",
                route_id: routeId,
            },
        };
        if (formMethod === "create") {
            createRoute(reqCreate);
        }
        if (formMethod === "update") {
            updateRoute(reqUpdate);
        }
    };

    const removeHandler = () => {
        if (routeId) deleteRoute({route_id: routeId});
    };

    useEffect(() => {
        const workspace = workspaces?.data.items.find(
            (space) => space.id === Number(workspaceId),
        );

        if (workspace) setWorkspaceName(workspace.name);
    }, [workspaceId, workspaces]);

    const cancelHandler = () => {
        navigate(`${APP_ROUTES.WORKSPACE}`);
    };

    const duplicateHandler = () => {
        const currentValues = getValues();
        const reqCreate = {
            ...currentValues,
            name: `${currentValues.name} (копия)`,
            work_space_id: workspaceId,
            method: currentValues.method,
            active: "false",
            logging_enable: currentValues.logging_enable.toString(),
        };
        createRoute(reqCreate);
    };

    useEffect(() => {
        if (route?.data.active) setValue("active", route?.data.active);
    }, [route?.data.active, setValue]);

    const backHandler = () => {
        navigate(`${APP_ROUTES.PRICE}`);
    };

    const handleUrlInfo = () => {
        return window.location.replace('/info/url');
    }

    const handleResponseInfo = () => {
        return window.location.replace('/info/response');
    }

    const handleCopyUrl = async () => {
        const urlValue = getValues('url') || '';
        const baseUrl = info?.data.url || '';
        const fullUrl = `${baseUrl}${urlValue}`;
        
        if (!fullUrl || fullUrl === '') {
            enqueueSnackbar("URL пуст, нечего копировать", {
                variant: "reportComplete",
                className: "error",
                preventDuplicate: true,
            });
            return;
        }
        
        // Попытка использовать современный Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(fullUrl);
                enqueueSnackbar("URL скопирован в буфер обмена", {
                    variant: "reportComplete",
                    className: "success",
                    preventDuplicate: true,
                });
                return;
            } catch (err) {
                console.error('Clipboard API error:', err);
                // Продолжаем к fallback методу
            }
        }
        
        // Fallback метод для старых браузеров или HTTP
        try {
            const textArea = document.createElement('textarea');
            textArea.value = fullUrl;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            
            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);
            
            if (successful) {
                enqueueSnackbar("URL скопирован в буфер обмена", {
                    variant: "reportComplete",
                    className: "success",
                    preventDuplicate: true,
                });
            } else {
                throw new Error('execCommand failed');
            }
        } catch (err) {
            console.error('Fallback copy error:', err);
            enqueueSnackbar("Ошибка при копировании. URL: " + fullUrl, {
                variant: "reportComplete",
                className: "error",
                preventDuplicate: true,
            });
        }
    }

    // const onChangeHandler = (event: InputEvent) => {
    //     try {
    //         setResponseData(JSON.parse(event.target.value))
    //     } catch (e) {
    //         setResponseData(event.target.value)
    //     }
    // };

    const onChange = React.useCallback((val, viewUpdate) => {
        setValuee(val);
    }, []);

    return (
        <>
            {formMethod === "create" || formMethod === "update" ? (
                <div>
                    <FormWrapper>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <HeaderForm>
                                <TitleWrap>
                                    <WorkspaceName>{workspaceName}</WorkspaceName>
                                    <RoutePageTitle>{titlePage}</RoutePageTitle>
                                </TitleWrap>
                                <Controller
                                    control={control}
                                    name="active"
                                    render={({field: {value, onBlur, onChange}}) => (
                                        <SwitchContainer>
                                            <label>Активен</label>
                                            <IOSSwitch
                                                onBlur={onBlur}
                                                value={value}
                                                onChange={onChange}
                                                checked={value}
                                            />
                                        </SwitchContainer>
                                    )}
                                />
                            </HeaderForm>
                            <FieldGroupWrapper>
                                <FieldGroup>
                                    <Controller
                                        control={control}
                                        name="name"
                                        render={({field: {value, onBlur, onChange}}) => (
                                            <StyledTextField
                                                onBlur={onBlur}
                                                variant="outlined"
                                                label="Имя"
                                                autoComplete="on"
                                                InputLabelProps={{
                                                    sx: {
                                                        "&.Mui-focused": {
                                                            color: `${palette.colors.green_base}`,
                                                        },
                                                        "&.Mui-error": {color: `${palette.colors.error}`},
                                                    },
                                                }}
                                                value={value}
                                                error={!!errors?.name?.message || !!errorsRequest?.name}
                                                helperText={
                                                    errors?.name?.message || errorsRequest?.name
                                                }
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                    <Controller
                                        control={control}
                                        name="description"
                                        render={({field: {value, onBlur, onChange}}) => (
                                            <StyledTextField
                                                onBlur={onBlur}
                                                variant="outlined"
                                                label="Описание метода"
                                                multiline
                                                inputProps={{maxLength: 1000}}
                                                autoComplete="on"
                                                rows={5}
                                                InputLabelProps={{
                                                    sx: {
                                                        "&.Mui-focused": {
                                                            color: `${palette.colors.green_base}`,
                                                        },
                                                        "&.Mui-error": {color: `${palette.colors.error}`},
                                                    },
                                                }}
                                                value={value}
                                                error={
                                                    !!errors?.description?.message ||
                                                    !!errorsRequest?.description
                                                }
                                                helperText={
                                                    errors?.description?.message ||
                                                    errorsRequest?.description
                                                }
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                    <FieldGroupRow gap={8}>
                                        <Controller
                                            control={control}
                                            name="method"
                                            render={({field: {value, onBlur, onChange}}) => (
                                                <StyledSelect
                                                    value={value}
                                                    onChange={onChange}
                                                    label="Метод"
                                                    onBlur={onBlur}
                                                    variant="outlined"
                                                    MenuProps={{
                                                        MenuListProps: {
                                                            sx: {
                                                                "&& .Mui-selected": {
                                                                    backgroundColor:
                                                                    palette.colors.button_text_hover,
                                                                },
                                                            },
                                                        },
                                                    }}
                                                >
                                                    {methods.map((item) => (
                                                        <MenuItem value={item.name} key={item.name}>
                                                            {item.name.toUpperCase()}
                                                        </MenuItem>
                                                    ))}
                                                </StyledSelect>
                                            )}
                                        />
                                        <StyledTextField
                                            variant="outlined"
                                            disabled
                                            InputLabelProps={{
                                                sx: {
                                                    "&.Mui-focused": {
                                                        color: `${palette.colors.green_base}`,
                                                    },
                                                    "&.Mui-error": {color: `${palette.colors.error}`},
                                                },
                                            }}
                                            value={info?.data.url}
                                        />
                                        <Controller
                                            control={control}
                                            name="url"
                                            render={({field: {value, onBlur, onChange}}) => (
                                                <StyledTextField
                                                    onBlur={onBlur}
                                                    variant="outlined"
                                                    label="URL"
                                                    autoComplete="on"
                                                    InputLabelProps={{
                                                        sx: {
                                                            "&.Mui-focused": {
                                                                color: `${palette.colors.green_base}`,
                                                            },
                                                            "&.Mui-error": {
                                                                color: `${palette.colors.error}`,
                                                            },
                                                        },
                                                    }}
                                                    value={value}
                                                    error={!!errors?.url?.message || !!errorsRequest?.url}
                                                    helperText={
                                                        errors?.url?.message || errorsRequest?.url
                                                    }
                                                    onChange={onChange}
                                                />
                                            )}
                                        />
                                        <VerticalCenter>
                                            <Link to="#" onClick={handleCopyUrl} style={{ marginRight: '8px' }}>
                                                <QuestionWrapper>
                                                    <CopyIcon />
                                                </QuestionWrapper>
                                            </Link>
                                            <Link to="#" onClick={handleUrlInfo}>
                                                <QuestionWrapper>
                                                    <QuestionIcon />
                                                </QuestionWrapper>
                                            </Link>
                                        </VerticalCenter>
                                    </FieldGroupRow>
                                    <Controller
                                        control={control}
                                        name="http_code"
                                        render={({field: {value, onBlur, onChange}}) => (
                                            <StyledTextField
                                                onBlur={onBlur}
                                                variant="outlined"
                                                label="HTTP code"
                                                autoComplete="on"
                                                InputLabelProps={{
                                                    sx: {
                                                        "&.Mui-focused": {
                                                            color: `${palette.colors.green_base}`,
                                                        },
                                                        "&.Mui-error": {color: `${palette.colors.error}`},
                                                    },
                                                }}
                                                value={value}
                                                error={
                                                    !!errors?.http_code?.message ||
                                                    !!errorsRequest?.http_code
                                                }
                                                helperText={
                                                    errors?.http_code?.message || errorsRequest?.http_code
                                                }
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                    <Controller
                                        control={control}
                                        name="content_type"
                                        render={({field: {value, onBlur, onChange}}) => (
                                            <StyledTextField
                                                onBlur={onBlur}
                                                variant="outlined"
                                                label="Content type"
                                                autoComplete="on"
                                                InputLabelProps={{
                                                    sx: {
                                                        "&.Mui-focused": {
                                                            color: `${palette.colors.green_base}`,
                                                        },
                                                        "&.Mui-error": {color: `${palette.colors.error}`},
                                                    },
                                                }}
                                                value={value}
                                                error={
                                                    !!errors?.content_type?.message ||
                                                    !!errorsRequest?.content_type
                                                }
                                                helperText={
                                                    errors?.content_type?.message ||
                                                    errorsRequest?.content_type
                                                }
                                                onChange={onChange}
                                            />
                                        )}
                                    />

                                    <Controller
                                        control={control}
                                        name="delay"
                                        render={({field: {value, onBlur, onChange}}) => (
                                            <StyledTextField
                                                onBlur={onBlur}
                                                variant="outlined"
                                                label="Задержка в миллисекундах"
                                                autoComplete="on"
                                                InputLabelProps={{
                                                    sx: {
                                                        "&.Mui-focused": {
                                                            color: `${palette.colors.green_base}`,
                                                        },
                                                        "&.Mui-error": {color: `${palette.colors.error}`},
                                                    },
                                                }}
                                                value={value}
                                                error={
                                                    !!errors?.delay?.message ||
                                                    !!errorsRequest?.delay
                                                }
                                                helperText={
                                                    errors?.delay?.message ||
                                                    errorsRequest?.delay
                                                }
                                                onChange={onChange}
                                            />
                                        )}
                                    />

                                    {/*<FieldGroupRow gap={2}>*/}
                                    <Controller
                                        control={control}
                                        name="response"
                                        render={({field: {value, onBlur, onChange}}) => (

                                            <CodeMirror value={responseData} height="200px" placeholder={'response'}
                                                        extensions={[javascript({jsx: true})]} onChange={onChange}/>

                                        )}
                                    />
                                        <Link to="#" onClick={handleResponseInfo}>
                                            <QuestionWrapper>
                                                <QuestionIcon />
                                            </QuestionWrapper>
                                        </Link>
                                    {/*</FieldGroupRow>*/}


                                    <Controller
                                        name="logging_enable"
                                        control={control}
                                        render={({field: {onChange, value}}) => (
                                            <CheckBoxContainer>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={value} onChange={onChange}/>
                                                    }
                                                    label="Вкл логирование запросов"
                                                />
                                            </CheckBoxContainer>
                                        )}
                                    />
                                </FieldGroup>
                            </FieldGroupWrapper>

                            <ButtonGroupWrapper>
                                <ButtonGroup>
                                    <Button
                                        text="Сохранить"
                                        variant="contained"
                                        type="submit"
                                        icon={<Check/>}
                                        borderradius="L"
                                        disabled={!isValid}
                                    />
                                    <Button
                                        text="Отменить"
                                        variant="text"
                                        borderradius="XXXL"
                                        onClick={cancelHandler}
                                    />
                                    {formMethod === "update" && (
                                        <Button
                                            text="Дублировать"
                                            variant="text"
                                            borderradius="XXXL"
                                            onClick={duplicateHandler}
                                            icon={<CopyIcon/>}
                                        />
                                    )}
                                </ButtonGroup>
                                {formMethod === "update" && (
                                    <DeleteIconWrapper onClick={deleteMethod}>
                                        <DeleteIcon/>
                                    </DeleteIconWrapper>
                                )}
                                <StyledDialog
                                    open={openDialog}
                                    onClose={handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                    sx={{
                                        backdropFilter: "blur(8px)",
                                    }}
                                >
                                    <DialogTitle id="alert-dialog-title">Удаление</DialogTitle>
                                    <DialogContent>
                                        <StyledDialogContentText id="alert-dialog-description">
                                            Вы уверены, что хотите удалить данные
                                        </StyledDialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button
                                            onClick={handleClose}
                                            text="Отмена"
                                            variant="text"
                                            borderradius="XXXL"
                                        />
                                        <Button
                                            onClick={removeHandler}
                                            text="Удалить"
                                            variant="filled"
                                            autoFocus
                                            borderradius="XXXL"
                                        >
                                            Agree
                                        </Button>
                                    </DialogActions>
                                </StyledDialog>
                            </ButtonGroupWrapper>
                        </form>
                    </FormWrapper>
                </div>
            ) : (
                <FormWrapper>
                    {!formMethod && (
                        <Back onClick={backHandler}>
                            <Arrow/>
                        </Back>
                    )}
                    <RoutePageTitle>Введение</RoutePageTitle>
                    <Text>
                        <div>
                            Рабочее пространство для тестирования API в LightBox предназначено
                            для совместного использования разработчиками и тестировщиками,
                            чтобы осуществлять полноценное тестирование API перед его выпуском
                            в продакшн. LightBox API предоставляет пользователям все
                            необходимые инструменты для тестирования методов API.
                        </div>
                        <div>
                            Вы можете создать своё собственное пространство в LightBox API или
                            использовать функцию автоматического построения API, которая
                            поможет вам быстро настроить и настроить ваше API.
                        </div>
                        <div>
                            Если у вас возникнут вопросы или у вас есть предложения по
                            улучшению сервиса, вы можете обратиться к разделам{" "}
                            <Link to="/help">«Вопросы по работе сервиса»</Link> и{" "}
                            <Link to="/offer">«Предложения по улучшению»</Link>. Ваш отзыв очень
                            важен для нас, и мы всегда готовы помочь вам в решении всех
                            вопросов.
                        </div>
                    </Text>
                </FormWrapper>
            )}
        </>
    );
};
